import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";


function UnitVOBT() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [vobtOptions, setVobtOptions] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_unit_vobt/`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setVobtOptions(response.data.vobt_data || []);

        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

useEffect(() => {
  if (token) {
    fetchOptions();
  }
}, [token]); 

  const groupedData = vobtOptions.reduce((acc, row) => {
    const key = row.id; // or row.bu_head

      if (!acc[key]) {
        acc[key] = {
          designation_id: row.designation_id,
          id: row.id,
          bu_head: row.bu_head,
          rows: [],
        };
      }

    acc[key].rows.push(row);

    return acc;
  }, {});

  const sortedGroups = Object.values(groupedData).sort((a, b) => {
      // First sort by designation_id ascending
      if (a.designation_id !== b.designation_id) {
        return Number(a.designation_id) - Number(b.designation_id);
      }

      // Then sort by user id ascending
      return Number(a.id) - Number(b.id);
    });

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
        <>
      {sortedGroups.map((group) => (
        <div className="card shadow-sm mb-4" key={group.bu_head}>
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
              <h4 className="mb-0">{group.bu_head} VoBT Analysis</h4>
            </div>

            <div className="table-responsive" style={{ maxHeight: "500px" }}>
              <table className="table text-nowrap table-bordered">
                <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1}}>
                  <tr>
                    <th className="sticky-col-1">FY</th>
                    <th>Target</th>
                    <th>Revenue</th>
                    <th>New Business</th>
                    <th>Closed Searches</th>
                    <th>Board</th>
                    <th>Non-Board</th>
                    <th>VOBT</th>
                    <th>Billable Comp</th>
                    <th>Total Fees</th>
                    <th>Avg VOBT</th>
                    <th>Avg Fee</th>
                    <th>ARPA</th>
                  </tr>
                </thead>

                <tbody>
                  {group.rows.map((row, index) => (
                    <tr key={`${row.id}-${row.financial_year}`}>
                      <td className="sticky-col-1">{row.financial_year}</td>
                      <td>{formatNumber(row.target)}</td>
                      <td>{formatNumber(row.revenue)}</td>
                      <td>{formatNumber(row.new_business)}</td>
                      <td>{row.closed_assignments}</td>
                      <td>{row.board_closed}</td>
                      <td>{row.non_board_closed}</td>
                      <td>{formatNumber(row.vobt)}</td>
                      <td>{formatNumber(row.billed_comp)}</td>
                      <td>{formatNumber(row.total_fee)}</td>
                      <td>{formatNumber(row.average_vobt)}</td>
                      <td>{row.average_fee_percent}</td>
                      <td>{formatNumber(row.arpa)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </>


        </>
    );
}

export default UnitVOBT;